 
import { KundeproduktOversikt, Log, PaginatedResult } from '../../../models';
import { baseApi } from '../queryApiCreator';
import { client } from '../../client';

export const kundeproduktOversiktQueryApiService = baseApi
.enhanceEndpoints({
  addTagTypes: ['produktOversikt'],
}).injectEndpoints({
    endpoints: (build) => {
      return {
        hentProduktVersjoner: build.query<KundeproduktOversikt[], void>({
          query: () => {
           return ({ request: client.get<KundeproduktOversikt[]>(`KundeproduktOversikt/hentKundensProdukter`)});
          },
          providesTags: [{ type: 'produktOversikt' }]
        }),
      };
    }
  }); 

